const AbstractRepository = require('@/lib/Repositories/AbstractRepository');
const DataStoreNames = require('@/lib/DataStores/DataStoreNames');
const ReturnReason = require('./ReturnReason');

class ReturnReasonRepository extends AbstractRepository {
    /**
     * @param {DataStore} dataStore
     * @param {Hydrator} hydrator
     * @param {SyncStateManager} syncStateManager
     * @param returnReasonResource
     */
    constructor(
        dataStore,
        hydrator,
        syncStateManager,
        returnReasonResource
    ) {
        super(dataStore, hydrator, syncStateManager);

        this.returnReasonResource = returnReasonResource;
    }

    getEntityClass() {
        return ReturnReason;
    }

    getEntityName() {
        return 'Return Reason';
    }

    getTableName() {
        return DataStoreNames.RETURN_REASONS;
    }

    getResource() {
        return this.returnReasonResource;
    }

    /**
     * @return {Promise<ReturnReason[]>}
     */
    findAll() {
        return super.findAll();
    }
}

module.exports = ReturnReasonRepository;
